import axios from 'axios';
import api from './api';

export default {
    fetchAllFlows() {
        return axios.post('/flow/fetchAllFlows/');
    },
};
